<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e2088760" style="color: #82a339"><b>GAZPACHO WITH CILANTRO CREAM</b></p>
<p class="ext" id="d7e2089260"><b><i>Recipes for this full-flavored, uncooked tomato-based soup abound. Ours is topped with a dollop of cilantro-spiked sour cream, a tasty combination.</i></b></p>
<p class="h4" id="d7e2090760" style="color: #496210"><b>Prep: 30 minutes plus chilling</b></p>
<p class="ul" id="d7e2091260">2 medium cucumbers (8 ounces each), peeled</p>
<p class="ul" id="d7e2091560">1 yellow pepper</p>
<p class="ul" id="d7e2091860">¼ small red onion</p>
<p class="ul" id="d7e2092760">2 pounds ripe tomatoes (5 medium), peeled, seeded, <br/> and chopped</p>
<p class="ul" id="d7e2093460">½ to 1 small jalapeño chile, seeded</p>
<p class="ul" id="d7e2094660">3 tablespoons fresh lime juice</p>
<p class="ul" id="d7e2094960">2 tablespoons extra-virgin olive oil</p>
<p class="ul" id="d7e2095360">¾ plus ⅛ teaspoon salt</p>
<p class="ul" id="d7e2097060">¼ cup reduced-fat sour cream or plain <br/> low-fat yogurt</p>
<p class="ul" id="d7e2098360">1 tablespoon milk</p>
<p class="ul" id="d7e2098660">4 teaspoons chopped fresh cilantro</p>
<p class="pub" id="d7e2099160" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> Chop half of 1 cucumber, half of yellow pepper, and all of onion into ¼-inch pieces; set aside. Cut remaining cucumbers and yellow pepper into large pieces.</p>
<p class="pub" id="d7e2101560"><span style="color: #c15b49"><b>2.</b></span> In blender or in food processor with knife blade attached, puree large pieces of cucumber and yellow pepper, tomatoes, jalapeño, lime juice, oil, and ¾ teaspoon salt until smooth. Pour puree into bowl; add cut-up cucumber, yellow pepper, and onion. Cover and refrigerate until well chilled, at least 6 hours or up to overnight.</p>
<p class="pub" id="d7e2105560"><span style="color: #c15b49"><b>3.</b></span> Prepare cilantro cream: In small bowl, stir sour cream, milk, cilantro, and remaining ⅛ teaspoon salt until smooth. Cover and refrigerate.</p>
<p class="pub" id="d7e2107760"><span style="color: #c15b49"><b>4.</b></span> To serve, top soup with dollops of cilantro cream. Makes about 5 cups or 4 first-course servings.</p>
<p class="ntx" id="d7e2109060">Each serving: About 156 calories, 4g protein, 17g carbohydrate, 10g total fat (2g saturated), 6mg cholesterol, 545mg sodium.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c59_r1.vue?c63463f6